import DOMPurify from "dompurify";

// Rich text from RichTextEditor.js (event welcomeContent) is rendered on the public,
// unauthenticated event page — sanitize at render time so a malicious admin (or a
// compromised admin account) can't use it as a stored-XSS vector against visitors.
const ALLOWED_TAGS = [
  "p", "br", "strong", "b", "em", "i", "u", "s", "strike",
  "ul", "ol", "li", "span", "h1", "h2", "h3", "blockquote", "a", "img",
];
const ALLOWED_ATTR = ["style", "href", "target", "rel", "src", "alt", "width", "height"];

export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || "", { ALLOWED_TAGS, ALLOWED_ATTR });
}

// Tiptap's editor.getHTML() returns "<p></p>" (not "") for an empty document,
// so callers gating on "is there real content" need tag-stripped emptiness.
export function isHtmlEmpty(html) {
  return !html || !html.replace(/<[^>]*>/g, "").trim();
}

export const escapeHtml = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// event.welcomeContent predates RichTextEditor and may still hold plain text (with
// literal newlines) saved from the old textarea. Feeding that straight into Tiptap or
// dangerouslySetInnerHTML would collapse the newlines, so convert it to paragraphs/<br>
// first. Content already saved by RichTextEditor is real HTML (starts with a tag) and
// is returned unchanged.
export function toEditableHtml(text) {
  if (!text) return "";
  if (/^\s*</.test(text)) return text;
  return text
    .split(/\n{2,}/)
    .map((para) => `<p>${escapeHtml(para).replace(/\n/g, "<br>")}</p>`)
    .join("");
}
